export interface PendoEventMap {
    'Message Hub Use Suggestion': { inbox: string; team_id: number; group_id: string | null; contact_id: number };
    'Message Hub Inbox Navigation': { inbox: string; team_id: number; group_id: string | null };
    'Message Hub Send': { inbox: string; team_id: number; group_id: string | null; contact_id: number };
    'Message Hub Suggested Reply Sent': { inbox: string; team_id: number; group_id: string | null; contact_id: number };
    'Quick Blast Cost Optimized': { team_id: number; group_id: string | null };
}

export type PendoEvent = {
    [K in keyof PendoEventMap]: [name: K, metadata: PendoEventMap[K]];
}[keyof PendoEventMap];

export const pendoEvent = <K extends keyof PendoEventMap>(
    name: K,
    metadata: PendoEventMap[K]
): [K, PendoEventMap[K]] => [name, metadata];

// window.pendo is absent in dev / disabled sessions; the agent stub queues calls made before it loads.
export const trackPendoEvent = ([name, metadata]: PendoEvent): void => {
    // each event should be independent rather than relying on the metadata for message hub inboxes
    let event: string = name;

    if ('inbox' in metadata && metadata.inbox) {
        event = name.concat(' ' + metadata.inbox.charAt(0).toUpperCase() + metadata.inbox.slice(1));
    }

    window.pendo?.track(event, metadata);
};
